module.exports = __webpack_public_path__ + "img/badge-safe-red.fa388061.svg";